import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Typography,
  Box,
  CardMedia,
  Switch,
  FormControlLabel,
  IconButton,
} from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';

interface ShireImageCardProps {
  id: string | number;
  title: string;
  description: string;
  imageUrl: string;
  isActive: boolean;
  onToggleActive?: (id: string | number, isActive: boolean) => void;
  onDelete?: (id: string | number) => void;
  onEdit?: (id: string | number) => void;
}

const ShireImageCard: React.FC<ShireImageCardProps> = ({
  id,
  title,
  description,
  imageUrl,
  isActive,
  onToggleActive,
  onDelete,
  onEdit,
}) => {
  const handleToggleActive = () => {
    onToggleActive?.(id, !isActive);
  };

  const handleDelete = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onDelete?.(id);
  };

  const handleEdit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onEdit?.(id);
  };

  return (
    <Card sx={{ maxWidth: 345, height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Image on top - full width */}
      <CardMedia
        component="img"
        height="200"
        image={imageUrl}
        alt={title}
        sx={{ objectFit: 'cover' }}
      />
      
      {/* Content */}
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography gutterBottom variant="h6" component="div" noWrap>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 3,
          WebkitBoxOrient: 'vertical',
        }}>
          {description}
        </Typography>
      </CardContent>

      {/* Action buttons at the bottom */}
      <CardActions sx={{ justifyContent: 'space-between', p: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {!!onToggleActive && (
          <FormControlLabel
            control={
              <Switch
                checked={isActive}
                onChange={handleToggleActive}
                color="primary"
              />
            }
            label={isActive ? 'Active' : 'Inactive'}
            labelPlacement="end"
          />
          )}
        </Box>
        
        <Box sx={{ display: 'flex', gap: 1 }}>
          {!!onDelete && (
          <IconButton
            size="small"
            color="error"
            onClick={handleDelete}
          >
            <Delete />
          </IconButton>
          )}
        </Box>
      </CardActions>
    </Card>
  );
};

export default ShireImageCard;
